const wishlist_api = 'https://ashluxe.ashcorp-api.com/api';

class WishlistManager {
  constructor() {
    this.loading = true;
    // this.wishlistCollectionId = this.getWishlistCollectionIdFromUrl();
    this.landing = true;
    this.wishlistCollectionId = window?.pageData?.wishlist_id || null;
    this.wishlistCollectionCode = window?.pageData?.wishlist_share_code || null;
    this.wishlistPage = window?.pageData?.wishlist_page || false;

    this.customerId = window.customerId || null;
    this.customerEmail = window.customerEmail || null;
    this.customerFirstName = window.customerFirstName || null;
    this.customerLastName = window.customerLastName || null;

    this.wishlistCollectionItemPrivateHeader = document.getElementById('wishlist__private-header');
    this.wishlistDashboardHeader = document.getElementById('wishlist__dashboard-header');
    this.wishlistCollectionItemPublicHeader = document.getElementById('wishlist__public-header');
    this.wishlistContainer = document.getElementById('wp-collection');
    this.wishlistCollectionItemContainer = document.getElementById('wi-collection-items');
    this.loadingState = document.getElementById('loading-state');
    this.emptyState = document.getElementById('empty-state');
    this.wishlistModal = document.getElementById('wishlist__modal');

    this.wishlist = JSON.parse(localStorage.getItem("wishlist") || "[]");
    this.wishlistCollection = JSON.parse(localStorage.getItem("wishlistCollection") || "[]");;
    this.shopifyProducts = [];
    // this.selectedProductsInPublic = JSON.parse(localStorage.getItem("selectedProductsInPublic") || "[]");
    // this.selectedProductsInPublic = [];
    this.selectedProductsInPublic = this.getSelected(this.wishlistCollectionCode);

    // Bind methods
    this.init = this.init.bind(this);
    this.loadWishlist = this.loadWishlist.bind(this);
    this.loadWishlistCollection = this.loadWishlistCollection.bind(this);
    this.renderWishlistLanding = this.renderWishlistLanding.bind(this);
    this.renderWishlistLoader = this.renderWishlistLoader.bind(this);
    this.renderItemsInWishlistPrivateHeader = this.renderItemsInWishlistPrivateHeader.bind(this);
    this.renderItemsInWishlistPublicHeader = this.renderItemsInWishlistPublicHeader.bind(this);
    this.renderWishlistDashboardHeader = this.renderWishlistDashboardHeader.bind(this);
    this.renderAllWishlistCollection = this.renderWishlist.bind(this);
    this.renderItemsInWishlistCollection = this.renderItemsInWishlistCollection.bind(this);
    this.removeFromWishlist = this.removeFromWishlist.bind(this);
    this.addToCart = this.addToCart.bind(this);
    this.addMultipleToCart = this.addMultipleToCart.bind(this);
    this.timeAgo = this.timeAgo.bind(this);

    this.saveWishlist = this.saveWishlist.bind(this);
    this.clearWishlist = this.clearWishlist.bind(this);
    this.saveWishlistCollection = this.saveWishlistCollection.bind(this);
    this.clearWishlistCollection = this.clearWishlistCollection.bind(this);
    this.saveSelected = this.saveSelected.bind(this);
    this.getSelected = this.getSelected.bind(this);
    this.clearSelected = this.clearSelected.bind(this);

    this.createWishlist = this.createWishlist.bind(this);
    this.uploadProfileImage = this.uploadProfileImage.bind(this);
    this.updateWishlist = this.updateWishlist.bind(this);
    this.renderWishlistCreateModal = this.renderWishlistCreateModal.bind(this);
    this.renderWishlistSignUpModal = this.renderWishlistSignUpModal.bind(this);
    this.handleAddToWishlist = this.handleAddToWishlist.bind(this);
    this.handleAddProduct = this.handleAddProduct.bind(this);
    this.saveToDB = this.saveToDB.bind(this);
    this.showToast = this.showToast.bind(this);
    this.handleDeleteProduct = this.handleDeleteProduct.bind(this);
    this.handleFetchShopifyProducts = this.handleFetchShopifyProducts.bind(this);
    this.addItemToWishlistListener = this.addItemToWishlistListener.bind(this);
    this.updateProductVariant = this.updateProductVariant.bind(this);
  }

  saveWishlist() {
    localStorage.setItem("wishlist", JSON.stringify(this.wishlist));
  }

  saveWishlistCollection() {
    localStorage.setItem("wishlistCollection", JSON.stringify(this.wishlistCollection));
  }

  clearWishlist() {
    this.wishlist = [];
    this.saveWishlist();
  }

  clearWishlistCollection() {
    this.wishlistCollection = [];
    this.saveWishlistCollection();
  }

  saveSelected() {
    localStorage.setItem(
      this.wishlistCollectionCode,
      JSON.stringify(this.selectedProductsInPublic)
    );
  }

  clearSelected() {
    localStorage.removeItem(this.wishlistCollectionCode);
  }

  getSelected() {
    return JSON.parse(localStorage.getItem(this.wishlistCollectionCode) || "[]");
  }

  showInit() {
    const html = `
      <div class="wishlist-init" style="margin-top: -32px;">
        <img
          src="${window.giftIconUrl}"
          alt="Wishlist empty" 
          width="160" 
          height="160"
        >
        <h2>Loading...</h2>
        <button type="button" class="wishlist-reload-btn hidden">Reload</button>
      </div>
    `;

    this.wishlistContainer.innerHTML = html;
  }

  async init() {
    // this.showLoading();
    // this.showInit();
    if (this.wishlistPage) {
      if (this.customerId) {
        if (this.wishlistCollectionId || this.wishlistCollectionCode) {
          // this.renderWishlistLoader("item");
          await this.loadWishlistCollection();
          // this.renderItemsInWishlistCollection();
        } else {
          await this.loadWishlist();
          this.renderWishlist();
          // console.log('THE WISHLIST LANDING - ', this.landing, this.wishlist.collections);

          // const items = Array.isArray(this.wishlist.collections) ? this.wishlist.collections : [];
          
          // if (this.landing && items.length === 0) {
          //   this.renderWishlistLanding();
          // } else {
          //   this.renderWishlist();
          // }
        }
      }
      else {
        if (this.wishlistCollectionCode) {
          // this.renderWishlistLoader("item");
          await this.loadWishlistCollection();
          // this.renderItemsInWishlistCollection();
        }
      }
    } else {
      if (this.customerId) {
        await this.loadWishlist();
      } else {
        // this.renderWishlistSignUpModal();
      }
    }
    this.attachEventListeners();
    // this.hideLoading();
  }

  renderWishlistLoader(type="dashboard") {
    const html = `
      <div class="wishlist-loader-container">
        <img
          src="${window.giftIconUrl}"
          alt="Wishlist empty" 
          width="120" 
          height="120"
        >
        <div class="wishlist-loader"></div>
      </div>`;

    if (type === "dashboard") {
      this.wishlistContainer.innerHTML = html;
    } else if (type === "item") {
      this.wishlistCollectionItemContainer.innerHTML = html;
    } else {
      return;
    }
  }

  getWishlistCollectionIdFromUrl() {
    const match = window.location.pathname.match(/\/wishlist\/(\d+)$/);
    return match ? match[1] : null;
  }

  showLoading() {
    this.loadingState.style.display = 'block';
    this.wishlistContainer.style.display = 'none';
  }

  hideLoading() {
    this.loadingState.style.display = 'none';
    this.wishlistContainer.style.display = 'block';
  }

  async loadWishlist() {
    try {
      const response = await fetch(`${wishlist_api}/wishlist/${customerId}`, {
        headers: { 'Content-Type': 'application/json' },
        method: "POST",
        cache: "no-store",
        body: JSON.stringify({
          customerId: window.customerData?.id,
          email: window.customerData?.email
        })
      });

      if (!response.ok) {
        // throw new Error(`Failed to load wishlist: ${response.statusText}`);
        this.wishlist = {
          id: this.customerId,
          first_name: this.customerFirstName,
          last_name: this.customerLastName,
          image: null,
          created_at: null,
          updated_at: null,
          collections: []
        };
        return;
      }
      const data = await response.json();

      // Save wishlist to the instance
      this.wishlist = data?.wishlist || [];
      this.saveWishlist();

      // Mark for if product has already been added to wishlist
      if (!this.wishlistPage) {
        if (this.wishlist?.collections?.length >= 1) {
            const saveBtnContainer = document.querySelector('button.wishlist-button');
            const saveBtn = document.querySelector('div.wishlist-button');
            const saveMobileBtn = document.querySelector('.wishlist-button-mobile');
            const saveText = document.querySelector('.remove-text');

            let noOfCol = 0;
            colLoop:
            for (const c of this.wishlist?.collections) {
              for (const p of c.products || []) {
                if (p.product_id === saveBtnContainer?.dataset?.productId) {
                  // saveBtn.classList.add('is-active');
                  // saveText.textContent = `${c.title}`;
                  // break;
                  noOfCol += 1;
                  continue colLoop;
                }
              }
            }

            if (noOfCol === 0) return;

            if (saveMobileBtn) {
              saveMobileBtn.innerHTML = `
                <img 
                  src="${window.wishlistActiveIconUrl}"
                  width=16
                  height=16
                />
              `;
            }

            if (saveBtn) {
              saveBtn.classList.add('is-active');
              saveText.textContent = `Added to ${noOfCol} Collection${noOfCol > 1 ? 's' : ''}`;
            }
        }
      }
    } catch (error) {
      // console.error('Error loading wishlist:', error);
      this.showError('Failed to load your wishlist. Please try again later.');
    }
  }

  async loadWishlistCollection() {
    let whichIdUrl = `${wishlist_api}/collection/${this.wishlistCollectionId}`;
    if (this.wishlistCollectionCode) {
      whichIdUrl = `${wishlist_api}/share/${this.wishlistCollectionCode}`
    }

    const options = {
      headers: { 'Content-Type': 'application/json' },
      cache: "no-store"
    };

    // Only add POST + body if wishlistCollectionCode exists
    if (this.wishlistCollectionCode) {
      options.method = "POST";
      options.body = JSON.stringify({
        customerId: window.customerId,
        email: window.customerEmail
      });
    } else {
      options.method = "GET";
    }

    const collectionId = this.wishlistCollectionId;

    try {
      const response = await fetch(`${whichIdUrl}`, options);

      if (!response.ok) {
        throw new Error(`Failed to load wishlist: ${response.statusText}`);
      }
      const data = await response.json();

      // Save wishlist to the instance
      this.wishlistCollection = data?.collection || [];
      this.saveWishlistCollection();

      
      // CHECK selected items still exist in wishlist
      const variantIdsInWishlist = this.wishlistCollection.products.map(
        (p) => p.variant_id
      );

      const allExist = this.selectedProductsInPublic.every((id) =>
        variantIdsInWishlist.includes(id)
      );

      if (!allExist) {
        this.selectedProductsInPublic = []
        this.saveSelected();
      }
      // end

      // if (this.wishlistCollectionCode) {
      this.wishlist = {
        ...this.wishlist,
        ...data?.wishlist
      }
      this.saveWishlist();
      // }

      // Fetch product details from Shopify
      // const productPromisesOld = this.wishlistCollection.products.map(async (item) => {
      //   try {
      //     const res = await fetch(`/products/${item.product_handle}.js`);
      //     if (!res.ok) throw new Error(`Failed to fetch product: ${item.product_handle}`);
      //     const product = await res.json();
      //     // return { ...product };
      //     console.log('OLD QUERY - ', product)
      //   } catch (err) {
      //     console.error(`Error fetching ${item.product_handle}:`, err);
      //     return null;
      //   }
      // });
      // Storefront API endpoint and token

      const endpoint = 'https://ashluxe.myshopify.com/api/2025-10/graphql.json';
      const STOREFRONT_ACCESS = 'a050087f7368a304b0d84928ae1a3010';

      // Fetch product details via GraphQL
      const productPromises = this.wishlistCollection.products.map(async (item) => {
        try {
          const { product_handle, variant_id } = item;

          const query = (handle) => `
          {
            product(handle: "${handle}") {
              id
              title
              handle
              descriptionHtml
              featuredImage {
                url
                altText
              }
              variants(first: 100) {
                edges {
                  node {
                    id
                    title
                    price {
                      amount
                      currencyCode
                    }
                    availableForSale
                    selectedOptions {
                      name
                      value
                    }
                  }
                }
              }
            }
          }
          `;
          
          const res = await fetch(endpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS,
            },
            body: JSON.stringify({ query: query(product_handle) }),
          });

          if (!res.ok) throw new Error(`GraphQL error: ${res.status}`);
          const json = await res.json();

          if (json.errors || !json.data?.product) {
            // console.warn(`Product not found: ${item.product_handle}`, json.errors);
            return null;
          }

          const node = json.data.product;

          // Helper to extract numeric ID
          function parseShopifyId(gid) {
            return gid ? (parseInt(gid.split('/').pop()) || gid.split('/').pop()) : null;
          }

          return {
            id: parseShopifyId(node.id),
            gid: node.id,
            title: node.title,
            handle: node.handle,
            description: node.descriptionHtml,
            featured_image: node.featuredImage ? node.featuredImage.url : "",
            variant_id,
            url: `https://www.ash-luxe.com/products/${node.handle}`,
            variants: node.variants.edges.map(({ node: v }) => ({
              id: parseShopifyId(v.id),
              title: v.title,
              price: v.price.amount,
              currency: v.price.currencyCode,
              available: v.availableForSale,
              options: v.selectedOptions,
            })),
          };
        } catch (err) {
          // console.error(`Error fetching ${item.product_handle}:`, err);
          return null;
        }
      });

      const productsWithData = (await Promise.all(productPromises)).filter(Boolean);
      this.wishlistCollection.products = productsWithData;

      // Now render it
      this.renderItemsInWishlistCollection();
    } catch (error) {
      // console.error('Error loading wishlist:', error);
      this.showError('Failed to load your wishlist. Please try again later.');
      
      if (this.wishlistCollectionItemContainer) {
        this.wishlistCollectionItemContainer.innerHTML = this.publicWishlistNotFound();
        document
          .querySelector('.wishlist-back-btn')
          .addEventListener('click', () => window.history.back());
              return;
            }
    }
  }

  async fetchProductDetails(handle) {
    try {
      const response = await fetch(`/products/${handle}.json`);
      if (!response.ok) throw new Error('Failed to fetch product');
      const p = await response.json();
      if (p.product) {
        return p.product;
      }
      return null;
    } catch (error) {
      // console.error(`Error fetching product ${handle}:`, error);
      return null;
    }
  }

  async removeFromWishlist(productId) {
    const lineItemContainer = document.querySelector(`.wishlist-item-${productId}`);

    // Add loading state
    lineItemContainer.style.transition = 'opacity 0.3s ease';
    lineItemContainer.style.opacity = '0';

    setTimeout(() => {
      lineItemContainer.remove();
    }, 300);

    try {
      const response = await fetch(wishlist_api, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          product_id: productId,
          user_id: window.customer.id,
        }),
      });

      if (!response.ok) throw new Error('Failed to remove item');

      // Remove item from local array and re-render
      // this.wishlist = this.wishlist.filter((item) => item.id !== productId);
      // this.renderAllWishlistCollection();
    } catch (error) {
      // console.error('Error removing item:', error);
      this.showError('Failed to remove item. Please try again.');
    }
  }

  async addToCart(productId, variantId, quantity = 1) {
    try {
      // 1. Clear the entire cart
      // await fetch('/cart/clear.js', {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' }
      // });

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: quantity,
            },
          ],
        }),
      });

      if (!response.ok) throw new Error('Failed to add to cart');

      this.showSuccess('Item added to cart!');
      // this.removeFromWishlist(productId);

      fetch('/cart.js')
        .then((res) => res.json())
        .then((cart) => {
          const cartCount = document.querySelector('.cart-count');
          if (cartCount) {
            cartCount.textContent = cart.item_count;
          }
        });
    } catch (error) {
      // console.error('Error adding to cart:', error);
      this.showError('Failed to add item to cart. Please try again.');
    }
  }

  async addMultipleToCart(variantIds = [], quantity = 1) {
    try {
      // 1. Clear the entire cart
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });

      // 2. Format the items array for Shopify
      const items = variantIds.map(id => ({
        id,
        quantity
      }));

      // 3. Add all items at once
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items }),
      });

      if (!response.ok) throw new Error('Failed to add items to cart');

      this.showSuccess('Items added to cart!');

      // 4. Update cart count
      const cartData = await fetch('/cart.js').then(res => res.json());
      const cartCount = document.querySelector('.cart-count');
      if (cartCount) {
        cartCount.textContent = cartData.item_count;
      }
    } catch (error) {
      // console.error('Error adding to cart:', error);
      this.showError('Failed to add items to cart. Please try again.');
    }
  }

  async buyNow(variantId, quantity = 1) {
    try {
      await this.addToCart(null, variantId, quantity);
      window.location.href = '/checkout';
    } catch (error) {
      // console.error('Error processing buy now:', error);
      this.showError('Failed to process purchase. Please try again.');
    }
  }

  showToast(text) {
    const toast = document.getElementById('wishlist-toast');
    toast.innerText = text;
    toast.classList.add('show');
    setTimeout(() => {
      toast.classList.remove('show');
    }, 2000); // hide after 2 seconds
  }

  async buyNowWithCartAttributes(variantIds, quantity = 1) {
    try {
      await this.addMultipleToCart(variantIds, quantity);
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          note: `wishlistShareId=${this.wishlistCollectionCode || ''}`,
          attributes: {
            wishlistId: '',
            wishlistShareId: this.wishlistCollectionCode.split('share_')[1] || '',
            senderFirstName: window.customerFirstName || '',
            senderLastName: window.customerLastName || ''
          }
        })
      });
      this.clearSelected();
      window.location.href = '/checkout';
    } catch (error) {
      // console.error('Error processing buy now:', error);
      this.showError('Failed to process purchase. Please try again.');
    }
  }

  itemCardTemplate(item, publicView=true, addView=false) {
    // --- Convert HTML description to plain text ---
    const tempEl = document.createElement('div');
    tempEl.innerHTML = item.description || '';
    const plainText = (tempEl.textContent || tempEl.innerText || '').trim();
    // --- Truncate to max 8 words ---
    const words = plainText.split(/\s+/);
    const truncatedText =
      words.length > 8 ? words.slice(0, 8).join(' ') + '…' : plainText;
    const noVariantAvailable = !(Array.isArray(item.variants) && item.variants.length > 0 && item.variants.some(v => v.available));
    const firstAvailableVariant = item.variants?.find(v => v.available);
    const price = addView 
      ? firstAvailableVariant?.price 
      : item.variants?.find(v => v.id === parseInt(item.variant_id))?.price;

    const savedVariantIsAvailable = !item.variant_id ||
      (Array.isArray(item.variants) &&
        item.variants.length > 0 &&
        item.variants.some(v => v.id === item.variant_id && v.available));

    const isSold = !savedVariantIsAvailable || noVariantAvailable;
    const badgeHTML = this.wishlistCollectionCode ? item.gifted
      ? `<span class="wi-badge ${isSold ? 'wi-badge--sold' : ''}">${item.gifted} Gifted</span>`
      : '' : '';
    const badgeSoldOut = isSold ? `<span class="wi-badge wi-badge--sold">Sold out</span>`
      : '';
    
    const whichVariant = !addView ? item.variant_id : firstAvailableVariant?.id;const savedVariant = item.variants.find(v => v.id === whichVariant);
    const savedVariantForMobile = item.variants.find(v => v.id === whichVariant);
    const savedSize = savedVariantForMobile?.options
      ?.find(opt => opt.name.toLowerCase() === "size")
      ?.value
      ?.toUpperCase() || "";


    return `
      <article class="wi-card wishlist-item wishlist-item-${item.id || ''}">
        <a class="wi-media wi-aspect-long ${isSold ? 'wi-muted' : ''}" href="${item.url}" aria-label="${item.title || ''}">
          ${badgeHTML} ${badgeSoldOut}
          ${item.featured_image ? `<img loading="lazy" src="${item.featured_image}" alt="${item.title || ''}">` : null}

          ${!publicView && !addView && 
            `<button type="button" class="wishlist-delete-btn" data-product-id=${item.id}>
              <img
                src="${window.trashIconUrl}"
                width="16"
                height="16"
              />
            </button>`}

          ${savedVariantIsAvailable && !addView && publicView &&
            `<button 
              type="button"
              class="wishlist-gift-btn ${this.selectedProductsInPublic.includes(`${item.variant_id}`) ? 'wishlist-gifted' : ''}" 
              data-product-id=${item.id}
              data-product-variant-id=${item.variant_id}
            ><img src="${window.giftboxIconUrl}" width="16" height="16" /><span>Gift item</span></button>`}
          
          ${item.variants && (addView || !publicView) && 
          `<div data-modal="${item.product_id}" class="wishlist-variant-options${!publicView && !addView ? ' options-dashboard' : ''} ${addView ? ' options-add' : ''}">
            ${item.variants
            .filter(variant => variant?.options?.find(opt => opt.name.toLowerCase() === 'size'))
            .map((variant, id) => {
              const sizeValue =
                variant.options.find(opt => opt.name.toLowerCase() === 'size')
                  ?.value.toUpperCase() || '';
              const checkedAttr =
                variant.id === whichVariant ? 'checked' : '';
              
                return`
                <label 
                class="
                  wishlist-variant-label 
                  ${!variant.available ? 'wishlist-muted' : ''}
                for="${variant?.id}">
                ${sizeValue}
                <input type="radio"
                  ${!variant.available ? 'disabled' : ''}
                  class="wishlist-variant ${addView ? 'add-variant' : 'saved-variant'}"
                  id="${variant?.id}"
                  name="${item.id || ''}" 
                  ${checkedAttr}
                  value="${variant.options.find(opt => opt.name.toLowerCase() === 'size')?.value.toUpperCase() || ''}"
                />
                </label>
              `}).join('')}
          </div>`
          }

          ${!publicView && 
            `<div class="wishlist-size-mobile-modal"></div>`
          }

          ${!publicView &&
            `<button 
              type="button"
              class="wishlist-size-mobile  ${addView ? 'options-product-add' : ''}"
              data-product-id=${item.product_id}
            ><span>${savedSize}</span> <img src="${window.chevronDownIconUrl}" width="14" height="14" /></button>`
          }

          ${!isSold && addView ?
            `<button 
              id=${item.id}
              type="button"
              class="wishlist-product-btn"
              data-product-handle=${item.handle}
              data-product-id=${item.id}
              data-product-image=${item.featured_image}
              data-product-variant-id=${firstAvailableVariant?.id}
            >
              Add item
            </button>` : ''
          }
        </a>

        <h3 class="wi-name">${item.title || ''}</h3>
        <div class="wi-brand">${truncatedText || ''}</div>

        <div class="wi-price">
          <span class="wi-now">${price && this.formatMoney(price)}</span>
        </div>
      </article>
    `;
  }

  cardTemplate(list) {
    const isPrivate = !list.public;
    const multi = (list.products||[]).length >= 2;

    // build media markup (either 2x2 grid or single image)
    let media = '';
    if(multi){
      const products = list.products.slice(0,3);
      media = `
        <div class="wishlist-media">
          ${isPrivate ? `<span class="wishlist-priv">Private</span>` : ``}
          <a class="wp-link-cover" href="/pages/wishlist/${list.id}" aria-label="${list.title}">
            <div class="wishlist-media-inner ${products.length === 3 && 'wishlist-media-multi-3'}">
              ${products.map(p=>`<img loading="lazy" src="${p.image_url}" alt="">`).join('')}
            </div>
          </a>
        </div>`;
    } else {
      const src = (list.products && list.products[0]?.image_url) || window.collectionDemoImg;
      media = `
        <div class="wishlist-media single">
          ${isPrivate ? `<span class="wishlist-priv">Private</span>` : ``}
          <a class="wp-link-cover" href="/pages/wishlist/${list.id}" aria-label="${list.title}"></a>
          ${src ? `<img loading="lazy" src="${src}" alt="">` : ``}
        </div>`;
    }

    return `
      <article class="wp-card">
        ${media}
        <h3 class="wishlist-card-title">${list.title||''}</h3>
        <div class="wishlist-card-meta">
          <span class="meta-item">${(list.no_of_items||0)} items</span>
          <span class="date-item">${this.timeAgo(list.created_at)||''}</span>
        </div>
      </article>
    `;
  }
  
  publicWishlistNotFound() {
    return `
      <div class="wishlist-empty" style="margin-top: -32px;">
        <img
          src="${window.giftIconUrl}" 
          alt="Wishlist empty" 
          width="160" 
          height="160"
        >
        <h2>This Wishlist is Expired or Hidden</h2>
        <p>Ask the owner to activate the Wishlist.</p>
        <button type="button" class="wishlist-back-btn">Back</button>
      </div>
    `
  }

  itemCardTemplateEmpty(publicView=true) {
    return `
      <div class="wishlist-empty">
        <img
          src="${window.giftIconUrl}" 
          alt="Wishlist empty" 
          width="160" 
          height="160"
        >
        <h2>${publicView ? 'This' : 'Your'} Wishlist is Empty</h2>
        ${publicView ? '<p>Ask the owner to add items to the wishlist' : '<p>Add items from the Ashluxe store to your Wishlist.</p>'}
        ${publicView ? '' : '<button type="button" class="wishlist-add-btn">Add Items</button>'}
      </div>
    `
  }

  renderItemsInWishlistPrivateHeader(collection) {
    const html = `
      <a class="wishlist-back" href="/pages/wishlist">
        <img src="${window.backIconUrl}" />
        <p>Back</p>
      </a>
      <h1 class="wishlist-title">${collection.title}</h1>

      <div class="wishlist-info">
        <p class="wishlist-badge">${collection.public ? 'Public' : 'Private'}</p>
        <p class="wishlist-meta">${collection.products?.length || 0} items</p>
        <span class="wishlist-meta">•</span>
        <p class="wishlist-meta">${collection.no_of_views || 0} views</p>
      </div>

      <div class="wishlist-cta">
        <button class="wishlist-share-btn">Share Wishlist</button>
        <button class="wishlist-edit-btn">Edit</button>
        <button class="wishlist-add-btn">Add Items</button>
        
        <button class="wishlist-edit-btn wishlist-mobile-btn">
          <img
            src="${window.pencilIconUrl}"
            alt="Edit"
            width="16"
            height="16"
          />
        </button>
        <button class="wishlist-share-btn wishlist-mobile-btn">
          <img
            src="${window.shareIconUrl2}"
            alt="Edit"
            width="16"
            height="16"
          /></button>
      </div>
    `;
    
    if (this.wishlistCollectionItemPrivateHeader) this.wishlistCollectionItemPrivateHeader.innerHTML = html;
  }

  renderItemsInWishlistPublicHeader(wishlist, collection) {
    const address = collection?.delivery_address?.address;
    const imageUrl = wishlist?.image || window.collectionDemoImg;
    const selCount = this.selectedProductsInPublic?.length || 0;

    const html = `
      <div class="wishlist-bio">
        <div class="wishlist-avatar" style="background-image: url('${window.wishlistBranding3}');"></div>
        <img 
          class="wishlist-avatar-img"
          src="${imageUrl}" 
          alt="${wishlist?.first_name} profile image" 
          width="100" 
          height="100"
        >

        <p class="wishlist-owner">${wishlist?.first_name} ${wishlist?.last_name}</p>
        <p class="wishlist-note">${collection?.wishlist_note}</p>
        <div class="wishlist-address">
          <img src="${window.packageIconUrl}" />
          <p>${collection?.share_id?.replace(/^share_/, "")}</p>
          <button class="wishlist-copy-btn" data-copy-value="${collection?.share_id?.replace(/^share_/, "")}">Copy Share Id</button>
        </div>
      </div>

      <div class="wishlist-info">
        <h1>Welcome to ${wishlist?.first_name}'s wishlist</h1>
        <h2 class="wishlist-title">${collection?.title}</h2>

        <div class="wishlist-checkout-public">
          <div></div>
          <button class="wishlist-checkout-btn">
            <div class="wishlist-checkout-counter ${selCount >= 1 ? '' : 'wishlist-counter-hidden'}">${selCount}</div>
            <span class="wishlist-checkout-text"><span>Checkout</span><img src="${window.basketIconUrl}" width="16" height="16" /></span>
          </button>
        </div>
        </div>
    `;
    
    if (this.wishlistCollectionItemPublicHeader) this.wishlistCollectionItemPublicHeader.innerHTML = html;
  }

  renderWishlistDashboardHeader(wishlist) {
    const imageUrl = wishlist?.image || window.collectionDemoImg;
    const html = `
      <h1 class="wishlist-title">Your Wishlist Dashboard</h1>

      <div class="wishlist-bio">
        <img 
          src="${imageUrl}" 
          alt="Wishlist Owner Avatar" 
          width="38"
          height="38"
          class="wishlist-upload-img"
        >
        <button type="button" class="wishlist-upload">
          <img src="${window.pencilIconUrl}" width="16" height="16" />
        </button>
        <p>${wishlist.first_name} ${wishlist.last_name}</p>
        <form id="upload-image-form">
          <input type="file" class="wishlist-profile-image" name="profileImage" accept="image/*" />
        </form>
        
        <div class="wishlist-cta">
          <button class="wishlist-create-btn">Create Wishlist</button>
        </div>
      </div>
    `;

    // const form = document.querySelector('#upload-image-form');
    // if (form) {
    //   form.addEventListener('submit', (e) => this.uploadProfileImage(e));
    // }
    
    if (this.wishlistDashboardHeader) this.wishlistDashboardHeader.innerHTML = html;
    
    // Attach the form submit event AFTER it exists in DOM
    this.uploadBtns = document.querySelectorAll('.wishlist-upload, .wishlist-upload-img');

    this.uploadBtns.forEach((btn) => {
      btn.addEventListener('click', this.uploadProfileImage);
    });

  }

  // Renders wishlist landing page
  renderWishlistLanding() {
    const html = `
      <div class="wishlist__landing">
        <img
          src="${window.wishlistBranding2}"
          class="wishlist-landing-img"
          alt="wishlist page image"
        />

        <div class="wishlist-landing-content">
          <div class="wishlist-landing-content-img">
            <img
              src="${window.landingIconUrl}"
              alt="wishlist page image"
            />
          </div>

          <h2>Build Your Perfect Wishlist</h2>
          <p>Create your wishlist your way—personalize it, share it, and make gifting easy for everyone. Relax and let the love find its way to you.</p>
          <button id="wishlist-landing-create-btn">Create Wishlist</button>
        </div>
      </div>
    `;

    this.wishlistLanding = document.querySelector('.wp-wrapper');
    if (this.wishlistContainer) this.wishlistContainer.innerHTML = html;
    
    document.getElementById('wishlist-landing-create-btn').addEventListener('click', e => {
      e.preventDefault();
      console.log('JUST WORKED')
      this.landing = false;
      this.renderWishlist();
    });

    this.attachEventListeners();
  }

  // Renders all wishlist collections
  renderWishlist() {
    const items = Array.isArray(this.wishlist.collections) ? this.wishlist.collections : [];

    let html = '';
    
    if (!items.length) {
    //   if (this.emptyState) this.emptyState.style.display = 'block';
    //   if (this.wishlistContainer) {
    //     this.wishlistContainer.innerHTML = this.itemCardTemplateEmpty('dashboard');
    //     return;
    //   }
      html = `
        <article class="wp-card wishlist-create-btn">
        
          <div class="wishlist-media">
            <div class="wp-link-cover">
              <div class="wishlist-media-inner">
                <img loading="lazy" src="${window.collectionDemoImg}" alt="create new">
              </div>
            </div>
          </div>

          <h3 class="wishlist-card-title">Let your friends gift you</h3>
          <div class="wishlist-card-meta">
            <span class="date-item">Share with friends</span>
          </div>
          <button 
            style="border: none; 
              text-align: left; 
              font-size: 12px; 
              font-weight: 500;
              color: #070707 !important; 
              padding-left: 0;
              background: transparent !important;
            "
          >Create wishlist</button>
        </article>
      `;
    } else {
      html = items.map(item => this.cardTemplate(item)).join('');
    }

    // this.emptyState.style.display = 'none';


    this.renderWishlistDashboardHeader(this.wishlist);
    this.wishlistContainer.innerHTML = html;
    this.attachEventListeners();
  }

  // Renders the products inside a single wishlist collection
  renderItemsInWishlistCollection() {
    this.renderItemsInWishlistPublicHeader(this.wishlist, this.wishlistCollection);
    this.renderItemsInWishlistPrivateHeader(this.wishlistCollection);

    const productItems = Array.isArray(this.wishlistCollection.products) ? this.wishlistCollection.products : [];

    const publicView = this.wishlistCollectionCode ? true : false;

    if (!productItems.length) {
      if (this.emptyState) this.emptyState.style.display = 'block';
      if (this.wishlistCollectionItemContainer) {
        this.wishlistCollectionItemContainer.innerHTML = this.itemCardTemplateEmpty(publicView);
        return;
      }
    }

    if (this.emptyState) this.emptyState.style.display = 'none';

    const selCount = this.selectedProductsInPublic?.length || 0;

    // const extraHtml = publicView ? `
    //   <div class="wishlist-checkout-public">
    //     <div></div>
    //     <button class="wishlist-checkout-btn">
    //       <div class="wishlist-checkout-counter ${selCount >= 1 ? '' : 'wishlist-counter-hidden'}">${selCount}</div>
    //       <span class="wishlist-checkout-text"><span>Checkout</span><img src="${window.basketIconUrl}" width="16" height="16" /></span>
    //     </button>
    //   </div>
    // ` : '';
    const extraHtml = '';

    const html = productItems.map(item => this.itemCardTemplate(item, publicView)).join('');
    if (this.wishlistCollectionItemContainer) this.wishlistCollectionItemContainer.innerHTML = extraHtml + html;


    // Reuse any button/quantity listeners you already wire up
    // if (typeof this.attachEventListeners === 'function') {
    //   this.attachEventListeners();
    // }
    this.attachEventListeners();
  }

  formatMoney(cents) {
    // return this + parseFloat((cents / 100).toFixed(2)).toLocaleString();
  }

  renderVariantOptions(product) {
    if (!product.variants || product.variants.length === 0) return '';

    return `
      <div class="variant-option">
        <select class="variant-select">
          ${product.variants.map((option) => `<option value="${option.id}">${option.title}</option>`).join('')}
        </select>
      </div>
    `;
  }

  handleAddToWishlist(e) {
    e.preventDefault();
    e.stopPropagation();
    const btn = e.currentTarget;
    const productData = {
      productId: btn.dataset.productId,
      productHandle: btn.dataset.productHandle,
      productImage: btn.dataset.productImage,
      productVariantId: btn.dataset.productVariantId,
    }
    // If product already in wishlist
    // if (btn.querySelector(':scope > .wishlist-button.is-active')) {
    //   return;
    // }

    if (this.customerId) {
      this.renderAddToWishlistModal(productData);
    } else {
      this.renderWishlistSignUpModal();
    }
  }

  productCardTemplate() {
    return `
      <div class="wishlist__modals-products-content">
        <div class="wishlist-header">
          <label for="wishlist-search-btn" class="wishlist-search">
            <img
              src="${window.searchIconUrl}"
              width="20"
              height="20"
            />
            <input id="wishlist-search-btn" class="wishlist-search-btn" placeholder="Ashluxe Summer Capsule" />
          </label>
        </div>

        <div class="wi-grid">
          <div class="wishlist-loader-container">
            <div class="wishlist-loader"></div>
          </div>
        </div>
      </div>
    `;
  }

  async handleFetchShopifyProducts(e) {
    const wishlistSearch = document.querySelector('.wishlist-search-btn');
    const searchTerm = wishlistSearch?.value || null;
    if (this.wishlistModal) {
      if (!this.wishlistModal.classList.contains('active')) {
        this.wishlistModal.classList.add('active');
        this.wishlistModal.innerHTML = this.productCardTemplate();
        this.attachEventListeners();
      }
      
    }

    const STOREFRONT_ACCESS = 'a050087f7368a304b0d84928ae1a3010';
    const endpoint = 'https://ashluxe.myshopify.com/api/2025-10/graphql.json';
    let allProducts = [];
    let hasNextPage = true;
    let cursor = null;

    try {
      while (hasNextPage) {
        // 👇 Add query filter if searchTerm exists
        const searchQuery = searchTerm
          ? `, query: "title:*${searchTerm}*"`
          : '';

        const query = `
          {
            products(first: 50${cursor ? `, after: "${cursor}"` : ''}${searchQuery}) {
              edges {
                cursor
                node {
                  id
                  title
                  handle
                  descriptionHtml
                  featuredImage {
                    url
                    altText
                  }
                  priceRange {
                    minVariantPrice {
                      amount
                      currencyCode
                    }
                    maxVariantPrice {
                      amount
                      currencyCode
                    }
                  }
                  variants(first: 100) {
                    edges {
                      node {
                        id
                        title
                        price {
                          amount
                          currencyCode
                        }
                        availableForSale
                        selectedOptions {
                          name
                          value
                        }
                      }
                    }
                  }
                }
              }
              pageInfo {
                hasNextPage
                endCursor
              }
            }
        }`;
        
        const res = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS,
          },
          body: JSON.stringify({ query }),
        });

        if (!res.ok) throw new Error(`Request failed: ${res.status}`);

        const json = await res.json();

        const productsData = json.data.products;
        const edges = productsData.edges;

        function parseShopifyId(gid) {
          return gid ? (parseInt(gid.split('/').pop()) || gid.split('/').pop()) : null;
        }

        // Map to simplified structure
        const products = edges.map(({ node }) => ({
          id: parseShopifyId(node.id), // numeric product ID
          gid: node.id,               // keep the GID if you still need it
          title: node.title,
          handle: node.handle,
          description: node.descriptionHtml,
          featured_image: node.featuredImage ? node.featuredImage.url : null,
          url: `https://www.ash-luxe.com/products/${node.handle}`,
          price: node.priceRange ? node.priceRange.minVariantPrice.amount : null, // ✅ added correct product price
          currency: node.priceRange ? node.priceRange.minVariantPrice.currencyCode : null, // ✅ added currency
          variants: node.variants.edges.map(({ node: v }) => ({
            id: parseShopifyId(v.id), // numeric variant ID
            title: v.title,
            price: v.price.amount,
            currency: v.price.currencyCode,
            available: v.availableForSale,
            options: v.selectedOptions,
          })),
        }));



        allProducts.push(...products);
        hasNextPage = productsData.pageInfo.hasNextPage;
        hasNextPage = false;
        cursor = productsData.pageInfo.endCursor;
      }

      // const res = await fetch(`/products.json?limit=250`);
      // if (!res.ok) throw new Error(`Failed to fetch products:`);
      // const results = await res.json();
      this.shopifyProducts = allProducts;

      this.renderAddItemModal();
    } catch (err) {
      // console.error(`Error fetching `, err);
      return null;
    }
  }

  async handleAddProduct(e) {
    e.preventDefault();
    const btn = e.currentTarget;
    const productData = {
      productId: btn.dataset.productId,
      productHandle: btn.dataset.productHandle,
      productImage: btn.dataset.productImage,
      productVariantId: btn.dataset.productVariantId,
    }
    
    const selectedCollection = this.wishlistModal.querySelector('input[name="wishlist-select"]:checked');
    const selectedVariant = document.querySelector('input.variant-selector:checked');
    const variantId = selectedVariant ? selectedVariant.dataset.optionValueId : null;
    
    try {
      const response = await fetch(`${wishlist_api}/collection/${this.wishlistCollectionId || selectedCollection.value}/product`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          wishlist_id: this.customerId,
          product_id: productData.productId,
          product_handle: productData.productHandle, 
          image_url: productData.productImage,
          variant_id: productData.productVariantId || variantId, 
          gifted: 0,
          quantity: 1,  
          title: "Polished Stylized Face cap",
          description: "Very fresh, custom and plush",
          price: "150000",
        }),
      });

      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.error || 'Failed to add item to wishlist');
      }

      const data = await response.json();
      this.renderCollectionOrItemCreatedModal('Item has been added to your Wishlist!', data?.product?.image_url);

      const newProduct = this.shopifyProducts.find(p => p.id === parseInt(productData.productId));
      if (this.wishlistPage && newProduct) {
        newProduct.variant_id = parseInt(data?.product?.variant_id);
        this.wishlistCollection.products.push(newProduct);
        this.saveWishlistCollection();
        this.renderItemsInWishlistCollection();
      }
      
      // Hide the item

    } catch (error) {
      this.showToast('Error adding product!');
      // console.error('Error adding to wishlist:', error);
    }
  }

  async handleDeleteProduct(e) {
    e.preventDefault();
    const btn = e.currentTarget;
    const productId = btn.dataset.productId;
    
    try {
      const response = await fetch(`${wishlist_api}/collection/${this.wishlistCollectionId}/product/${productId}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          wishlist_id: this.customerId
        }),
      });

      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.error || 'Failed to delete item from wishlist');
      }

      const data = await response.json();
      this.renderCollectionOrItemCreatedModal('Item has been deleted from the Wishlist!', data?.product?.image_url);

      const id = parseInt(productId, 10);
      
      const idx = this.wishlistCollection.products.findIndex(p => p.id === id);
      if (idx > -1) {
        this.wishlistCollection.products.splice(idx, 1);
        this.renderItemsInWishlistCollection();
      }
      this.attachEventListeners();
      
      // Hide the item

    } catch (error) {
      // console.error('Error adding to wishlist:', error);
      return;
    }
  }

  attachEventListeners() {
    this.wishlistPdpAddBtn = document.querySelectorAll('.wishlist-pdp-add-btn');
    this.wishlistPdpAddBtn.forEach((btn) => {
      btn.addEventListener('click',  this.saveToDB);
    });

    this.wishlistAddItemBtn = document.querySelectorAll('.wishlist-add-btn');
    this.wishlistAddItemBtn.forEach((btn) => {
      btn.addEventListener('click',  this.handleFetchShopifyProducts);
    });

    this.wishlistVariants = Array.from(
      document.querySelectorAll('input[type="radio"].wishlist-variant.add-variant')
    ).filter(input => !input.disabled);
    
    this.wishlistVariants.forEach((input) => {
      const mobileBtn = input.closest('.wi-media').querySelector('.wishlist-size-mobile span');
      
      const closeModals = (target) => {
        const name = target.name || target.getAttribute('name') || null;
        const value = target.id || target.getAttribute('id') || null;

        // Update the dataset value
        const hiddenField = document.getElementById(name);
        if (hiddenField) {
          hiddenField.dataset.productVariantId = value;
        }

        // Find and close the modals
        const grandparent = target.closest('.wi-media');
        if (!grandparent) return;

        const wrapper = grandparent.querySelector('.wishlist-size-mobile-modal');
        const modal = grandparent.querySelector('.wishlist-variant-options.options-add');

        if (wrapper) wrapper.classList.remove('active');
        if (modal) modal.classList.remove('active');
      };

      // Trigger when the selected value CHANGES
      input.addEventListener('change', (e) => {
        mobileBtn.innerText = e.target.value;
        closeModals(e.target);
      });

      // Trigger EVEN IF the same radio is clicked again
      input.addEventListener('click', (e) => {
        mobileBtn.innerText = e.target.value;
        closeModals(e.target);
      });

    });


    this.wishlistVariants = Array.from(
      document.querySelectorAll('input[type="radio"].wishlist-variant.saved-variant')
    ).filter(input => !input.disabled);

    this.wishlistVariants.forEach((input) => {
      
      const handler = (e) => {
        e.preventDefault();
        const target = e.target;

        const name = target.name || target.getAttribute('name') || null;
        const value = target.id || target.getAttribute('id') || null;
        if (!name || !value) return;

        // Your existing function
        this.updateProductVariant(name, value);
      };

      input.addEventListener('change', handler);
      input.addEventListener('click', handler); // <— this is the fix
    });

    this.wishlistSearchItemInputs = document.querySelectorAll('.wishlist-search-btn');
    let searchTimeout;
    this.wishlistSearchItemInputs.forEach((input) => {
      input.addEventListener('input', (e) => {
        clearTimeout(searchTimeout);
        const searchTerm = e.target.value.trim();
        searchTimeout = setTimeout(() => {
          this.handleFetchShopifyProducts(searchTerm);
        }, 500);
      });
    });

    this.wishlistCreateBtns = document.querySelectorAll('.wishlist-create-btn');
    this.wishlistCreateBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
      e.preventDefault();

      if (this.wishlistModal) {
        this.renderWishlistCreateModal();
        this.wishlistModal.classList.add('active');
      }
      });
    });

    async function copy(value) {
      await navigator.clipboard.writeText(value);
    }
    this.wishlistCopyBtns = document.querySelectorAll('.wishlist-copy-btn');
    this.wishlistCopyBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
      e.preventDefault();

      const value = btn.dataset.copyValue;
      const input = document.querySelector('.wishlist-share-input');
      try {
        // copy(input.value);
        copy(value);
        this.showToast('Copied!');
      } catch (err) {
        // console.error('Failed to copy:', err);
        this.showToast('Failed to copy!');
      }
      
      });
    });

    this.wishlistCancelBtns = document.querySelectorAll('.wishlist-cancel-btn');
    this.wishlistCancelBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
      e.preventDefault();
        if (this.wishlistModal) {
          this.wishlistModal.classList.remove('active');
        }
      });
    });

    this.wishlistEditBtns = document.querySelectorAll('.wishlist-edit-btn');
    this.wishlistEditBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
      e.preventDefault();

      if (this.wishlistModal) {
        this.renderWishlistEditModal();
        this.wishlistModal.classList.add('active');
      }
      });
    });

    this.wishlistShareBtns = document.querySelectorAll('.wishlist-share-btn');
    this.wishlistShareBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
      e.preventDefault();

      if (this.wishlistCollection?.products?.length === 0) {
        this.showToast('Add at least one product')
      } else if (!this.wishlistCollection?.share_id) {
        this.showToast('Go to edit to complete wishlist details to enable sharing!');
        const editBtn = document.querySelector('.wishlist-edit-btn.wishlist-mobile-btn');
        
        if (editBtn) {
          // Inject keyframes only once
          if (!document.getElementById('blink-orange-keyframes')) {
            const style = document.createElement('style');
            style.id = 'blink-orange-keyframes';
            style.textContent = `
              @keyframes blinkBorderInline {
                0% { 
                  border-color: #f76308;
                  box-shadow: 0 0 0 1px #f76308;
                }
                100% { 
                  border-color: transparent;
                  box-shadow: 0 0 0 1px transparent;
                }
              }
            `;
            document.head.appendChild(style);
          }

          // Apply inline styles
          editBtn.style.border = '1px solid #f76308';
          editBtn.style.boxShadow = '0 0 0 1px #f76308';
          editBtn.style.animation = 'blinkBorderInline 0.25s ease-in-out infinite alternate';

          // Remove after 3 seconds
          setTimeout(() => {
            editBtn.style.border = '';
            editBtn.style.boxShadow = '';
            editBtn.style.animation = '';
          }, 2000);

        }
      } else if (this.wishlist?.image === null) {
        this.showToast('Add your profile image to continue!')
      } else if (this.wishlistCollection?.public === false) {
        this.showToast('Go to edit and make your wishlist "Shareable"')
      } else {
          if (this.wishlistModal) {
            this.renderWishlistShareModal(`https://ash-luxe.com/pages/wishlist/${this.wishlistCollection?.share_id}`);
            this.wishlistModal.classList.add('active');
          }
        }
      });
    });

    this.wishlistButtons = document.querySelectorAll('.wishlist-button-container, .wishlist-button-mini, .wishlist-button-mobile, .wishlist-button-plp');
    this.wishlistButtons.forEach((btn) => {
      btn.addEventListener('click',  this.handleAddToWishlist);
    });

    this.wishlistAddProduct = document.querySelectorAll('.wishlist-product-btn');
    this.wishlistAddProduct.forEach((btn) => {
      btn.addEventListener('click',  this.handleAddProduct);
    });

    this.wishlistAddProduct = document.querySelectorAll('.wishlist-delete-btn');
    this.wishlistAddProduct.forEach((btn) => {
      btn.addEventListener('click',  this.handleDeleteProduct);
    });

    // Edit wishlist script - accordions
    const accordions = document.querySelectorAll('.wishlist__modals-edit-content .accordion');

    accordions.forEach(acc => {
      const header = acc.querySelector('.wishlist__modals-edit-content .accordion-header');
      const content = acc.querySelector('.wishlist__modals-edit-content .accordion-content');
      const radio = acc.querySelector('.wishlist__modals-edit-content input[type="radio"]');

      header.addEventListener('click', () => {
        accordions.forEach(a => {
          a.classList.remove('active');
          a.querySelector('.wishlist__modals-edit-content .accordion-content').classList.remove('open');
          a.querySelector('.wishlist__modals-edit-content input[type="radio"]').checked = false;
        });

        acc.classList.add('active');
        content.classList.add('open');
        radio.checked = true;
      });
    });


    // Remove buttons
    document.querySelectorAll('.remove-button').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const productId = btn.dataset.productId;
        btn.disabled = true;
        this.removeFromWishlist(productId);
      });
    });

    document.querySelectorAll('.wishlist-size-mobile').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const modal = btn.parentElement.querySelector('.wishlist-variant-options.options-dashboard, .wishlist-variant-options.options-add');
        const wrapper = btn.parentElement.querySelector('.wishlist-size-mobile-modal');

        if (wrapper) {
          wrapper.classList.add('active');
        }

        if (modal) {
          modal.classList.add('active');
        }
      });
    });

    document.querySelectorAll('.wishlist-size-mobile-modal').forEach((wrapper) => {
      wrapper.addEventListener('click', (e) => {
        e.preventDefault();
        const modal = wrapper.parentElement.querySelector('.wishlist-variant-options.options-dashboard, .wishlist-variant-options.options-add');

        if (modal) {
          modal.classList.remove('active');
          wrapper.classList.remove('active');
        }
      });
    });

    // document.querySelectorAll('.wishlist-variant-label').forEach((label) => {
    //   label.addEventListener('click', (e) => {
    //     e.preventDefault();
    //     const parent = label.closest('.wi-media');
    //     const modal = parent.querySelector('.wishlist-variant-options.options-dashboard, .wishlist-variant-options.options-add');
    //     const wrapper = parent.querySelector('.wishlist-size-mobile-modal');

    //     if (modal && wrapper) {
    //       modal.classList.remove('active');
    //       wrapper.classList.remove('active');
    //     }
    //   });
    // });

    // Add to cart buttons
    document.querySelectorAll('.wishlist-gift-btn').forEach((btn) => {
      if (btn.dataset.listenerAttached === "true") return; // already attached
      btn.dataset.listenerAttached = "true";

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const giftBtn = e.currentTarget;
        const giftBtnText = giftBtn.querySelector('span');
        const variantId = giftBtn.dataset.productVariantId;
        const counter = document.querySelector('.wishlist-checkout-counter');

        if (!variantId) {
          this.showToast('An error occured!');
          return;
        }

        if (this.selectedProductsInPublic.includes(variantId)) {
          // remove the variantId
          this.selectedProductsInPublic = this.selectedProductsInPublic.filter(id => id !== variantId);
          this.saveSelected();

          this.showToast('Product removed from gift box!');
          giftBtn.classList.remove('wishlist-gifted');
          giftBtnText.innerText = 'Gift item';
          
          const numSelected = this.selectedProductsInPublic.length;
          if (numSelected === 0) {
            counter.classList.add('wishlist-counter-hidden');
          }
          counter.innerText = numSelected;
          return;
        } 
        
        if (!this.selectedProductsInPublic.includes(variantId)) {
          // add the variantId
          this.selectedProductsInPublic.push(variantId);
          this.saveSelected();

          this.showToast('Product added to gift box!');
          giftBtn.classList.add('wishlist-gifted');
          giftBtnText.innerText = 'Gift Added';

          const numSelected = this.selectedProductsInPublic.length;
          if (numSelected > 0) {
            counter.classList.remove('wishlist-counter-hidden');
          }
          counter.innerText = numSelected;
          return;
        }

        // btn.disabled = true;
        // this.buyNowWithCartAttributes(variantId);

        // btn.innerText = 'Added to Cart';
        // this.buyNow(variantId);
      });
    });

    
    document.querySelectorAll('.wishlist-checkout-btn').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.selectedProductsInPublic.length === 0) {
          this.showToast('Select at least one product!');
          return;
        }

        if (this.selectedProductsInPublic.length > 0) {
          btn.disabled;
          document.querySelector('.wishlist-checkout-btn span').innerText = 'Processing...';
          this.buyNowWithCartAttributes(this.selectedProductsInPublic);
        }
      });
    });

    // Buy now buttons
    document.querySelectorAll('.buy-now-button').forEach((button) => {
      button.addEventListener('click', (e) => {
        const productId = e.target.dataset.productId;
        const lineItemContainer = e.target.closest('.wishlist-item');
        const quantityInput = lineItemContainer.querySelector(`.quantity-input`);
        const variantId = lineItemContainer.querySelector(`.variant-select`).value;
        const quantity = parseInt(quantityInput.value, 10);
        this.buyNow(variantId, quantity);
      });
    });

    // Quantity
    document.querySelectorAll('.wishlist-items .number-input').forEach((button) => {
      button.addEventListener('click', (e) => {
        const productId = e.target.dataset.productId;
        const lineItemContainer = e.target.closest('.wishlist-item');
        const quantityInput = lineItemContainer.querySelector(`.quantity-input`);
        const variantId = lineItemContainer.querySelector(`.variant-select`).value;
        const quantity = parseInt(quantityInput.value, 10);
        this.buyNow(variantId, quantity);
      });
    });
  }
    
  async updateProductVariant(productId, variantId) {
    try {
    const response = await fetch(`${wishlist_api}/collection/${this.wishlistCollectionId}/product/${productId}/variant`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        wishlist_id: this.customerId,
        variant_id: variantId
      }),
    });

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.error || 'Failed to add item to wishlist');
    }

    const data = await response.json();
    this.renderCollectionOrItemCreatedModal('Product size has been updated!', data?.product?.image_url);
    
    if (this.wishlistCollection?.products && Array.isArray(this.wishlistCollection.products)) {
      this.wishlistCollection.products = this.wishlistCollection.products.map((product) => {
        if (product.id === parseInt(data?.product?.product_id)) {
          return {
            ...product,
            variant_id: parseInt(data?.product?.variant_id),
          };
        }
        return product;
      });
    }

    setTimeout(() => {
      this.renderItemsInWishlistCollection();
    }, 1200);
    } catch (error) {
      // console.error('Error adding to wishlist:', error);
      return;
    }
  }

  formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'NGN',
    }).format(cents);
  }
  
  timeAgo(dateString) {
    const date = new Date(dateString);
    const now = new Date();
    const seconds = Math.floor((now - date) / 1000);

    const intervals = {
      yr: 31536000,
      mon: 2592000,
      wk: 604800,
      day: 86400,
      hr: 3600,
      min: 60,
      sec: 1
    };

    for (let key in intervals) {
      const value = Math.floor(seconds / intervals[key]);
      if (value > 0) {
        return value === 1 ? `${value} ${key}` : `${value} ${key}s`;
      }
    }
  }

  showError(message) {
    // Implement your error notification system
    console.log(message);
  }

  showSuccess(message) {
    // Implement your success notification system
    console.log(message);
  }

  renderAddItemModal() {
    const productItems = Array.isArray(this.shopifyProducts) ? this.shopifyProducts : [];

    // if (!productItems.length) {
    //   if (this.emptyState) this.emptyState.style.display = 'block';
    //   if (this.wishlistCollectionItemContainer) {
    //     this.wishlistCollectionItemContainer.innerHTML = this.itemCardTemplateEmpty(publicView);
    //     return;
    //   }
    // }

    if (this.emptyState) this.emptyState.style.display = 'none';

    const wishlistIds = this.wishlistCollection.products.map(p => p.id);


    // const html = productItems
    //   .map(item => this.itemCardTemplate(item, false, true))
    //   .join('');

    const html = productItems
      .filter(item => !wishlistIds.includes(parseInt(item.id))) // ✅ skip items already in wishlist
      .map(item => this.itemCardTemplate(item, false, true))
      .join('');

    this.wishlistModal.querySelector('.wishlist__modals-products-content .wi-grid').innerHTML = html;
    
    // Reuse any button/quantity listeners you already wire up
    if (typeof this.attachEventListeners === 'function') {
      this.attachEventListeners();
    }
  }

  renderWishlistCreateModal() {
    const html = `
      <div class="wishlist__modals-create-content" style="background-image: url('${window.wishlistBranding}');">
      <img 
        src="${window.bannerIconUrl}" 
        alt="Wishlist Icon" 
        width="116"
        height="120"
      />
      <h2>Create Wishlist</h2>
      <p>Create and share your dream list of gifts with friends and loved ones.</p>
      <form id="wishlist-create-form">
        <input 
          type="text" 
          id="collection-title" 
          name="collection-title"
          placeholder="Enter Wishlist Title*"
          required 
        />
        <button class="wishlist-main-create-btn" type="submit">Create</button>
      </form>
      </div>
    `;

    this.wishlistModal.innerHTML = html;
    this.attachEventListeners();

    // Attach the form submit event AFTER it exists in DOM
    const form = this.wishlistModal.querySelector('#wishlist-create-form');
    if (form) {
      form.addEventListener('submit', (e) => this.createWishlist(e));
    }
  }

  addItemToWishlistListener(productData) {
    const wishlist_api = 'https://ashluxe.ashcorp-api.com/api';
    const form = document.getElementById('pdp_add_item');
    if (!form) return;
    
    // “Create Wishlist” trigger
    const createTrigger = document.getElementById('wishlist-create-trigger');
    if (createTrigger) {
      createTrigger.addEventListener('click', () => this.renderWishlistCreateModal());
    }
  }
    
  async saveToDB(e) {
    e.preventDefault();
    const btn = e.currentTarget;

    const productData = {
      productId: btn.dataset.productId,
      productHandle: btn.dataset.productHandle,
      productImage: btn.dataset.productImage,
      productVariantId: btn.dataset.productVariantId
    }

    // ✅ Get selected radio button value
    const selectedWishlistInput = document.querySelector('input[name="wishlist-select"]:checked');
    const collectionId = selectedWishlistInput ? selectedWishlistInput.value : null;
    const collectionTitle = selectedWishlistInput ? selectedWishlistInput.getAttribute('data-title') : null;


    if (!collectionId) {
      this.showToast('Please select a wishlist first.');
      return;
    }

    if (!productData?.productVariantId) {
      this.showToast('Please select a size option.');
      return;
    }

    try {
      const response = await fetch(`${wishlist_api}/collection/${collectionId}/product`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          wishlist_id: this.customerId,
          customerId: this.customerId,
          email: this.customerEmail,
          product_id: productData?.productId,
          product_handle: productData?.productHandle,    
          title: "Polished Stylized Face cap",
          description: "Very fresh, custom and plush",
          price: "150000",
          image_url: productData?.productImage,
          gifted: 0,
          quantity: 1,
          variant_id: productData?.productVariantId,
        }),
      });

      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.error || 'Failed to add item to wishlist');
      }

      const data = await response.json();
      this.renderCollectionOrItemCreatedModal('Item has been added to your Wishlist!', productData.productImage);

      // Extract the new product
      const newProduct = data.product;

      // Update the matching collection
      this.wishlist.collections = this.wishlist.collections.map((col) => {
        if (col.id === collectionId) {
          return {
            ...col,
            products: [...(col.products || []), newProduct],
          };
        }
        return col;
      });

      const saveBtnContainer = document.querySelector('button.wishlist-button');
      const saveBtn = document.querySelector('div.wishlist-button');
      const saveMobileBtn = document.querySelector('.wishlist-button-mobile');
      const saveText = document.querySelector('.remove-text');

      // Check the no. of Collections that has the product
      let noOfCol = 0;

      collectionLoop:
      for (const c of this.wishlist?.collections) {
        for (const p of c.products || []) {
          if (p.product_id === saveBtnContainer?.dataset?.productId) {
            // saveBtn.classList.add('is-active');
            // saveText.textContent = `${c.title}`;
            // break;
            noOfCol += 1;
            continue collectionLoop;
          }
        }
      }
      // saveText.textContent = `${collectionTitle}`;

      if (saveMobileBtn) {
        saveMobileBtn.innerHTML = `
          <img 
            src="${window.wishlistActiveIconUrl}"
            width=16
            height=16
          />
        `;
      }

      if (saveBtn) {
        saveBtn.classList.add('is-active');
        saveText.textContent = `Added to ${noOfCol} Collection${noOfCol > 1 ? 's' : ''}`;
      }

    } catch (error) {
      // console.error('Error adding to wishlist:', error);
      this.showToast('Error adding product!');
    }
  }

  renderAddToWishlistModal(data) {
    const html = `
      <form id="pdp_add_item" class="wishlist__modals-choose-content">
        <div class="wishlist-choose-header">
          <h2>Add to Wishlist</h2>
          <button class="wishlist-add-content-mobile wishlist-create-btn ${this.wishlist?.collections?.length === 0 ? 'hidden' : ''}">
            <img src="${window.plusIconUrl}" width="14" height="14" /> 
            New
          </button>
        </div>

        ${this.wishlist?.collections.map((list) => {
          const alreadyInCollection = list.products.some(p => p.product_id == data.productId);
          return `
          <label class="wishlist-choose-item" for="${list.id}">
            <img 
              src="${list?.products?.[0]?.image_url || window.collectionDemoImg}" 
              alt="avatar" 
              width="44"
              height="44"
            />
            <div class="wishlist-item-info">
              <h3>${list.title}</h3>
              <span class="wishlist-quantity">${list.products?.length || 0} items</span>
              <span class="wishlist-badge">${list.public ? 'Public' : 'Private'}</span>
            </div>
            ${alreadyInCollection ? '' : `<input type="radio" id="${list.id}" name="wishlist-select" value="${list.id}" data-title="${list.title}"/>`}
          </label>`}).join('')}

        <div class="wishlist-add-content wishlist-create-btn ${this.wishlist?.collections?.length >= 1 ? 'hidden' : ''}" id="wishlist-create-trigger">
          <img 
            src="${window.plusIconUrl}" 
            alt="create wishlist" 
            width="24"
            height="24"
          />
          <h4>Create Wishlist</h4>
          <p>Start a new wishlist for this item</p>
        </div>

        <div class="wishlist-actions">
          <button type="button" class="wishlist-cancel-btn">Cancel</button>
          <button 
            type="button" 
            class="wishlist-pdp-add-btn"
            data-product-id=${data.productId}
            data-product-handle=${data.productHandle}
            data-product-image=${data.productImage}
            data-product-variant-id=${data.productVariantId}
          >Add to Wishlist</button>
        </div>
      </form>
    `;

    // “Create Wishlist” trigger
    const createTrigger = document.getElementById('wishlist-create-trigger');
    if (createTrigger) {
      createTrigger.addEventListener('click', () => this.renderWishlistCreateModal());
    }

    this.wishlistModal.innerHTML = html;
    this.attachEventListeners();
    this.wishlistModal.classList.add('active');
  }
  
  renderWishlistSignUpModal() {
    const html = `
      <div class="wishlist__modals-signup-content" style="background-image: url('${window.wishlistBranding}');">
        <p>Almost there! 😉</p>
        <h2>Sign up to add items to your Wishlist.</h2>
        <img 
          src="${window.bannerIconUrl}" 
          class="wishlist-signup-img"
          alt="Wishlist Icon" 
          width="116"
          height="120"
        />
       <button id="wishlist-signup-btn">Sign Up</button>
      </div>
    `
    this.wishlistModal.innerHTML = html;
    this.attachEventListeners();
    this.wishlistModal.classList.add('active');
    
    // Click handler
    document.getElementById('wishlist-signup-btn').addEventListener('click', e => {
      e.preventDefault();
      console.log('JUST WORKED')
      localStorage.setItem('redirect_to_wishlist', true);
      window.location.replace('/account/register');
      // no preventDefault
    });
  }

  renderCollectionOrItemCreatedModal(message, imgSrc=window.collectionDemoImg, toast=false) {
    const html = `
      <div class="wishlist__modals-created-content" style="background-image: url('${window.wishlistBranding}');">
        ${!toast ? `
          <img 
            src="${window.confettiIconUrl}" 
            class="wishlist-congrats-img"
            alt="Congrats" 
            width="63"
            height="63"
          />`
          : ''
        }
        <h2>${message}</h2>
        ${!toast ? `
          <img 
            src="${imgSrc}" 
            class="wishlist-created-img"
            alt="Wishlist Icon" 
            width="186"
            height="194"
          />`
          : ''
        }
      </div>
    `;

    this.wishlistModal.classList.add('active');
    this.wishlistModal.innerHTML = html;
    setTimeout(() => {
      this.wishlistModal.classList.remove('active');
    }, 1200);
    this.attachEventListeners();
  }  

  renderWishlistEditModal() {
    // Format expiry_date if it exists
    const expiryDate = this.wishlistCollection?.expiry_date 
      ? new Date(this.wishlistCollection?.expiry_date).toISOString().split("T")[0]
      : '';
    const addressPrivate = this.wishlistCollection?.delivery_address_type === 'private' ? true : false;
    // const del_add = addressPrivate ? this.wishlistCollection?.delivery_address : {};
    const del_add = this.wishlistCollection?.delivery_address;

    const html = `
      <div class="wishlist__modals-edit-content">
        <h2>Add to Wishlist</h2>

        <form id="wishlist-edit-form" class="wishlist-edit-form">
          <div class="wishlist-info">
            <label>Wishlist Title*</label>
            <input 
              type="text" 
              id="wishlist-title" 
              name="wishlist-title"
              placeholder="26th Birthday-April"
              value="${this.wishlistCollection?.title || ''}"
              required
            />
              
            <label>Expiry Date</label>
            <input 
              type="date" 
              id="expiry-date"
              name="expiry-date"
              value="${expiryDate}"
              required
            />
            <label>Wishlist Note</label>
            <textarea 
              type="text" 
              id="wishlist-note" 
              name="wishlist-note"
              placeholder="A selection of gifts I’d truly appreciate. Thank you for being part of this moment with me xoxo...💕"
              rows=5
              required
            >${this.wishlistCollection?.wishlist_note || ''}</textarea>
          </div>

          <div class="wishlist-shipping">
            <label>Delivery Address</label>
            <p class="del-address">This is the shipping address that will be publicly displayed on your Wishlist page. Your Wishlist Gifters would be able to fill this information during checkout and payment.</p>
                
            <!-- Accordion 1 -->
            <div class="accordion active">
              <div class="accordion-header">
                <label>Your Address</label>
                <input type="radio" name="wishlist-shipping" value="private" ${addressPrivate ? 'checked' : ''} />
              </div>
              <div class="accordion-content ${addressPrivate ? 'open' : ''}">
                <input type="text" id="wishlist-country" name="wishlist-country" class="address-input" placeholder="Country" value="${del_add?.country || ''}" />
                <input type="text" id="wishlist-address" name="wishlist-address" class="address-input" placeholder="Address" value="${del_add?.address || ''}" />
                <div style="display: flex; gap: 10px;">
                  <input type="text" id="wishlist-apartment" name="wishlist-apartment" class="address-input" placeholder="Apartment, Suite etc. (optional)" value="${del_add?.apartment || ''}" />
                  <input type="text" id="wishlist-city" name="wishlist-city" class="address-input" placeholder="City" value="${del_add?.city || ''}" />
                </div>
                <input type="text" id="wishlist-state" name="wishlist-state" class="address-input" placeholder="State" value="${del_add?.state || ''}" />
                <input type="text" id="wishlist-phone" name="wishlist-phone" class="address-input" placeholder="Phone Number" value="${del_add?.phone || ''}" />
                <input type="text" id="wishlist-postcode" name="wishlist-postcode" class="address-input" placeholder="Postcode" value="${del_add?.postcode || ''}" />
                <p class="notice">*Privacy Notice:</p>
                <p class="ship-text">Your shipping address will be visible to your gifters at checkout. 
                  To keep it private, select the Ashluxury Store option below. 
                  Check out our <a href="">Shipping Policy</a>.
                </p>
              </div>
            </div>

            <!-- Accordion 2 -->
            <div class="accordion">
              <div class="accordion-header">
                <label>Ashluxury Store</label>
                <input type="radio" name="wishlist-shipping" value="public" ${addressPrivate ? '' : 'checked'} />
              </div>
              <div class="accordion-content ${addressPrivate ? '' : 'open'}">
                <p class="ash-addr">Address: 21B Admiralty Way</p>
                <p class="notice">*Notice:</p>
                <p class="ship-text">This option is perfect if you’d like to collect all items purchased 
                  by your gifters at once. You can either pick them up in-store or have 
                  them delivered to your preferred location. 
                  Check out our <a href="">Shipping Policy</a>.
                </p>
              </div>
            </div>

            <div class="consent-container">
              <input 
                type="radio" 
                id="wishlist-consent" 
                name="wishlist-consent"
                ${this.wishlistCollection?.consent ? 'checked': ''}
              />
              <label for="wishlist-consent">I consent to displaying the above address publicly on my Wishlist page.</label>
            </div>

            <div class="checkbox-container">
              <input 
                type="checkbox" 
                id="wishlist-status"
                name="wishlist-status"
                ${this.wishlistCollection?.public ? 'checked' : ''}
              />
              <label for="wishlist-status">Shareable (recommended)<span>This wishlist can be shared with friends and family using a unique link</span></label>
            </div>
            
            <div class="wishlist-actions">
              <button type="button" class="wishlist-cancel-btn">Cancel</button>
              <button type="submit" class="wishlist-save-btn">Save Changes</button>
            </div>
          </div>
        </form>
      </div>

      <script>
        const accordions = document.querySelectorAll('.wishlist__modals-edit-content .accordion');

        accordions.forEach(acc => {
          const header = acc.querySelector('.wishlist__modals-edit-content .accordion-header');
          const content = acc.querySelector('.wishlist__modals-edit-content .accordion-content');
          const radio = acc.querySelector('.wishlist__modals-edit-content input[type="radio"]');

          header.addEventListener('click', () => {
            accordions.forEach(a => {
              a.classList.remove('active');
              a.querySelector('.wishlist__modals-edit-content .accordion-content').classList.remove('open');
              a.querySelector('.wishlist__modals-edit-content input[type="radio"]').checked = false;
            });

            acc.classList.add('active');
            content.classList.add('open');
            radio.checked = true;
          });
        });
      </script>
    `;

    this.wishlistModal.innerHTML = html;
    this.attachEventListeners();
    this.wishlistModal.classList.add('active');

    // Attach the form submit event AFTER it exists in DOM
    // const form = this.wishlistModal.querySelector('#wishlist-edit-form');
    // if (form) {
      // form.addEventListener('submit', (e) => this.updateWishlist(e));
    this.wishlistSaveBtn = document.querySelector('.wishlist-save-btn');
    this.wishlistSaveBtn.addEventListener('click', this.updateWishlist)
    // }
  }

  renderWishlistShareModal(share_url) {
    const html = `
      <div class="wishlist__modals-share-content" style="background-image: url('${window.wishlistBranding}');">
        <h2>Your Wishlist is All Set<br>to Share!</h2>

        <div class="wishlist-share-linkrow">
          <input class="wishlist-share-input" type="text" value="${share_url}" readonly>
          <button type="button" data-copy-value="${share_url}" class="wishlist-copy-btn">
              <img 
                src="${window.copyWhiteIconUrl}" 
                alt="copy" 
                width="26"
                height="26"
              />
          </button>

          <div class="wishlist-share-social">
            <a
              href="https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(share_url)}"
            >
              <img 
                src="${window.facebookIconUrl}" 
                alt="facebook" 
                width="56"
                height="56"
              />
            </a>

            <a
              href="https://wa.me/?text=${encodeURIComponent(share_url)}"
            >
              <img 
                src="${window.whatsappIconUrl}" 
                alt="whatsapp" 
                width="56"
                height="56"
              />
            </a>
          </div>
        </div>

        <div class="wishlist-share-actions">
          <button class="wishlist-edit-btn">Edit Wishlist</button>
          <a class="wishlist-view-btn" href="${share_url}">View Public Wishlist</a>
        </div>
      </div>
    `;

    this.wishlistModal.innerHTML = html;
    this.attachEventListeners();
    this.wishlistModal.classList.add('active');
  }

  async createWishlist(e) {
    e.preventDefault();
    const input = this.wishlistModal.querySelector('#collection-title');
    const title = input ? input.value.trim() : '';

    if (!title) {
      this.showToast('Please enter a wishlist title.');
      return;
    }

    const formattedTitle = title.charAt(0).toUpperCase() + title.slice(1);

    const wishlistId = this.customerId || window.customer?.id || null;
    if (!wishlistId) {
      this.showError('User ID not found.');
      return;
    }
    
    const wishlistBtn = document.querySelector('.wishlist-button-container, .wishlist-button-plp');
    const productData = {
      productId: wishlistBtn?.dataset.productId || null,
      productHandle: wishlistBtn?.dataset.productHandle || null,
      productImage: wishlistBtn?.dataset.productImage || null,
      productVariantId: wishlistBtn?.dataset.productVariantId || null
    }

    try {
      const response = await fetch(`${wishlist_api}/wishlist/${wishlistId}/collection`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          title: formattedTitle,
          first_name: this.customerFirstName,
          last_name: this.customerLastName,
          customerId: this.customerId,
          email: this.customerEmail,
          image: null,

          // Optional
          product_id: productData?.productId,
          product_handle: productData?.productHandle,
          description: "Very fresh, custom and plush",
          price: "150000",
          image_url: productData?.productImage,
          gifted: 0,
          quantity: 1,
          variant_id: productData?.productVariantId,
        }),
      });
      
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.error || 'Failed to create wishlist collection');
      }

      const data = await response.json();
      // console.log('Created wishlist collection:', data);

      // Close the modal and show success feedback
      if (data?.products?.length > 0) {
        this.renderCollectionOrItemCreatedModal('Product added to new collection!', productData.productImage);
      } else {
        this.renderCollectionOrItemCreatedModal('Collection has been created!');
      }
      let newCollection = data.collection;
      newCollection.products = data.products || [];

      setTimeout(() => {
        if (data.collection && data.collection.id) {
          // Add to the first position
          this.wishlist.collections.unshift(newCollection);

          // Only run in wishlist page
          if (this.wishlistPage) {
            this.renderWishlist();
          }
        }
      }, 1200);

    } catch (err) {
      // console.error('Create wishlist error:', err);
      this.showError('Failed to create wishlist. Please try again.');
    }
  }

  async uploadProfileImage(e) {
    e.preventDefault();
    const fileInput = document.querySelector('.wishlist-profile-image');
    // const uploadBtn = document.querySelector('.wishlist-upload-btn'); // the button that triggered this function
    let fileSelected = false;

    // 1️⃣ If no file selected, open file picker
    // if (fileInput.files.length === 0) {
      // Listen for when a file becomes selected
      fileInput.onchange = () => {
        if (fileInput.files.length > 0) {
          const maxSize = 1 * 1024 * 1024; // 2MB in bytes
          const file = fileInput.files[0];

          if (file.size > maxSize) {
            this.showToast("File size must be less than 1MB.");
            fileInput.value = "";
            return;
          }

          // uploadBtn.textContent = 'Save'; // change button text
          // uploadBtn.classList.add('save');
          fileSelected = true;
          processFile.call(this, file); // proceed to upload
        }
      };

      fileInput.click();
      // return;
    // }

    if (!fileSelected) return;

    async function processFile(file) {
      // 2️⃣ If file already exists, proceed with upload
      // uploadBtn.textContent = 'Saving...';
      // uploadBtn.classList.remove('save');
      // uploadBtn.classList.add('saving');

      // 3️⃣ If file exists, continue upload
      // const file = fileInput.files[0];
      const wishlistId = this.customerId || window.customer?.id || null;

      const formData = new FormData();
      formData.append('profileImg', file);

      try {
        const response = await fetch(`${wishlist_api}/wishlist/${wishlistId}/upload`, {
          method: 'POST',
          body: formData
        });
        
        // if (!response.ok) {
        //   const err = await response.json().catch(() => ({}));
        //   throw new Error(err.error || 'Failed to upload wishlist profile image');
        // }

        const data = await response.json();

        // Close the modal and show success feedback
        this.renderCollectionOrItemCreatedModal('Profile image has been updated!');

        setTimeout(() => {
          if (data.wishlist && data.wishlist.id) {
            this.wishlist = {
              ...this.wishlist,
              image: data.wishlist?.image
            }
            this.saveWishlist();
            
            this.renderWishlist();
          }
        }, 1200);

      } catch (err) {
        // console.error('Upload image error:', err);
        this.showError('Failed to upload. Please try again.');
      } finally {
        // uploadBtn.textContent = 'Upload image';
        // uploadBtn.classList.remove('save');
        // uploadBtn.classList.remove('saving');
      }
    }
  }

  async updateWishlist(e) {
    e.preventDefault();
    
    const title = this.wishlistModal.querySelector('#wishlist-title').value;
    const expiry_date = this.wishlistModal.querySelector('#expiry-date').value;
    const wishlist_note = this.wishlistModal.querySelector('#wishlist-note').value;
    const wishlist_public = this.wishlistModal.querySelector('input[name="wishlist-status"]');

    const delivery_address_type = this.wishlistModal.querySelector('input[name="wishlist-shipping"]:checked').value;

    let delivery_address = {}
    // const house_number = this.wishlistModal.querySelector('#wishlist-house-number').value;
    const address = this.wishlistModal.querySelector('#wishlist-address').value;
    const apartment = this.wishlistModal.querySelector('#wishlist-apartment').value;
    const phone = this.wishlistModal.querySelector('#wishlist-phone').value;
    const country = this.wishlistModal.querySelector('#wishlist-country').value;
    const state = this.wishlistModal.querySelector('#wishlist-state').value;
    const city = this.wishlistModal.querySelector('#wishlist-city').value;
    const postcode = this.wishlistModal.querySelector('#wishlist-postcode').value;
    
    const consent = this.wishlistModal.querySelector('input[name="wishlist-consent"]').checked;
    const phoneRegex = /^(07|08|09)\d{9}$/;

    if (!title) {
      this.showToast('Please enter a wishlist title.');
      return;
    }

    if (!expiry_date) {
      this.showToast('Please select an expiry date.');
      return;
    }

    if (!wishlist_note) {
      this.showToast('Please add a wishlist note.');
      return;
    }

    if (!delivery_address_type) {
      this.showToast('Please select a delivery address type.');
      return;
    }

    if (!consent) {
      this.showToast('You must agree to terms and conditions.');
      return;
    }

    if (delivery_address_type === 'private') {
      if (!country) {
        this.showToast('Please enter your country.');
        return;
      }

      if (!address) {
        this.showToast('Please enter your address.');
        return;
      }

      if (!city) {
        this.showToast('Please enter your city.');
        return;
      }

      if (!state) {
        this.showToast('Please enter your state.');
        return;
      }

      if (!phone) {
        this.showToast('Please enter your phone number.');
        return;
      }

      if (!phoneRegex.test(phone)) {
        this.showToast('Invalid phone number.');
        return;
      }
      
      delivery_address = {
        "country": country,
        "address": address,
        "apartment": apartment,
        "city": city,
        "state": state,
        "phone": phone,
        "postcode": postcode
      }
    }

    const formattedTitle = title.charAt(0).toUpperCase() + title.slice(1);

    const wishlistId = this.customerId || window.customer?.id || null;
    if (!wishlistId) {
      this.showError('User ID not found.');
      return;
    }

    const details = JSON.stringify({
      wishlist_id: wishlistId,
      title: formattedTitle,
      expiry_date,
      wishlist_note,
      public: wishlist_public.checked,
      delivery_address_type,
      ...(delivery_address_type === 'private' ? { delivery_address } : {}),
    })

    try {
      const response = await fetch(`${wishlist_api}/collection/${this.wishlistCollectionId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: details
      });

      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.error || 'Failed to update wishlist collection');
      }

      const data = await response.json();

      // Close the modal and show success feedback
      this.showToast('Collection has been updated!');
      // this.renderCollectionOrItemCreatedModal('Collection has been Updated!', window.collectionDemoImg, true);
      // this.wishlistModal.classList.remove('active');

      const initialProducts = this.wishlistCollection?.products;
      this.wishlistCollection = {
        ...data?.collection,
        // delivery_address: data?.delivery_address,
        products: initialProducts
      }
      this.wishlist = {
        ...this.wishlist,
        ...data?.wishlist
      }
      this.saveWishlist();
      this.saveWishlistCollection();

      this.renderItemsInWishlistCollection();
      this.wishlistModal.classList.remove('active');

    } catch (err) {
      // console.error('Update wishlist error:', err);
      this.showError('Failed to update wishlist. Please try again.');
    }
  }

}

// Initialize the wishlist manager
document.addEventListener('DOMContentLoaded', () => {
  // Look for the wishlist link in the menu
  const wishlistLink = document.querySelector('li.menu-item a[href="/pages/wishlist"]');
  const wishlistIconLink = document.querySelector('a.ghost.wishlist-icon');

  if (wishlistLink) {
    wishlistLink.style.display = "flex";
    wishlistLink.style.alignItems = "center";

    const badge = document.createElement("span");
    badge.className = "wishlist-new-badge";
    badge.innerText = "New";

    // insert before the </a> closing tag
    wishlistLink.appendChild(badge);

    wishlistLink.addEventListener('click', e => {
      e.preventDefault();
      const href = wishlistLink.getAttribute('href');
      if (!window.customerId) {
        localStorage.setItem('redirect_to_wishlist', true);
      }
      window.location.href = href;
    });
  }

  if (wishlistIconLink) {
    wishlistIconLink.addEventListener('click', e => {
      e.preventDefault();
      const href = wishlistIconLink.getAttribute('href');
      if (!window.customerId) {
        localStorage.setItem('redirect_to_wishlist', true);
      }
      window.location.href = href;
    });
  }

  // const wishlistLandingBtn = document.getElementById('wishlist-landing-create-btn');
  // if (wishlistLandingBtn) {
  //   wishlistLandingBtn.addEventListener('click', e => {
  //     e.preventDefault();
  //     console.log('JUST WORKED NOW')
  //     this.landing = false;
  //     this.renderWishlist();
  //   });
  // }

  if (!window.__WishlistLoaded) {
    window.__WishlistLoaded = true;
    const wishlistManager = new WishlistManager();
    wishlistManager.init();
  }

});



{/* <div class="wishlist-filter-btns">
  <button class="wishlist-action-btn">
    <img
      src="${window.funnelIconUrl}"
      width="16"
      height="16"
    />
    Filter
  </button>
  <button class="wishlist-action-btn">
    Sort by
    <img
      src="${window.chevronDownIconUrl}"
      width="16"
      height="16"
    />
  </button>
</div> */}